import groupArrow from '@/assets/images/groupArrow.svg';
import { applyVideoDownloadSafeguards } from '@/helpers/preventVideoDownload';
import { pickUrl, resolveContentGroupThumbnail } from '@/helpers/closedCampaignThumbnail';

export const groupMoveButton = () => {
  if (window.storeeelItems.isMobile) return;
  // 呼び出し時に削除
  const existingButtons = document.querySelectorAll('.leftGroupButtonFrame, .rightGroupButtonFrame');
  existingButtons.forEach(button => button.remove());
  // 一時的なコンテナを作成
  const container = document.createElement('div');

  // 共通スタイル設定用ヘルパー
  const applyButtonStyles = (el, position) => {
    Object.assign(el.style, {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '10px',
      padding: '16px',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
      borderRadius: '16px',
      position: 'absolute',
      bottom: '20px',
      cursor: 'pointer',
      [position]: '20px',
      maxWidth: '200px',
      minWidth: '200px',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
    });
  };

  // テキスト用スタイル
  const applyTextStyles = el => {
    Object.assign(el.style, {
      fontWeight: '700',
      color: '#FFF',
      fontSize: '14px',
      lineHeight: '18.2px',
      whiteSpace: 'normal',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitBoxOrient: 'vertical',
      WebkitLineClamp: '2',
      wordWrap: 'break-word',
      flex: '1',
    });
  };

  // 画像用スタイル
  const applyImageStyles = (el, url) => {
    Object.assign(el.style, {
      width: '50px',
      height: '50px',
      borderRadius: '25px',
      backgroundImage: `url(${url})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      userSelect: 'none',
      WebkitUserSelect: 'none',
    });
    if (typeof el.setAttribute === 'function') {
      el.setAttribute('draggable', 'false');
    }
  };

  // アイコン用スタイル
  const applyIconStyles = (el, rotate = false) => {
    Object.assign(el.style, {
      width: '24px',
      height: '24px',
      userSelect: 'none',
      WebkitUserSelect: 'none',
      WebkitUserDrag: 'none',
      ...(rotate && { transform: 'rotate(180deg)' }),
    });
    el.setAttribute('draggable', 'false');
  };

  const resolveGroupPreview = (contentGroup) => {
    const groupThumbnail = resolveContentGroupThumbnail(contentGroup);
    const legacyImageUrl = pickUrl(contentGroup?.imageUrl, contentGroup?.image_url);
    if (groupThumbnail?.kind === 'video') {
      return { tagName: 'video', url: groupThumbnail.url };
    }
    if (groupThumbnail?.kind === 'image') {
      return { tagName: 'img', url: groupThumbnail.url };
    }
    if (legacyImageUrl) {
      return { tagName: 'img', url: legacyImageUrl };
    }

    const mediaAsset = contentGroup?.contents?.[0]?.mediaAsset;
    const mimeType = mediaAsset?.attachmentData?.metadata?.mime_type || '';
    const mediaUrl = mediaAsset?.mediaUrl || '';
    if (mimeType.includes('video')) {
      return { tagName: 'video', url: mediaUrl };
    }
    if (mimeType.includes('image')) {
      return { tagName: 'img', url: mediaUrl };
    }

    return null;
  };

  // — 左ボタン —
  if (window.prevGroup) {
    const leftBtn = document.createElement('div');
    leftBtn.className = 'leftGroupButtonFrame';
    applyButtonStyles(leftBtn, 'left');

    const preview = resolveGroupPreview(window.prevGroup);
    if (preview) {
      const imgDiv = document.createElement(preview.tagName);
      if (preview.tagName === 'video') {
        imgDiv.muted = true;
        imgDiv.src = `${preview.url}#t=0.1`;
        imgDiv.style.objectFit = 'cover';
        applyVideoDownloadSafeguards(imgDiv);
      }
      const icon = document.createElement('img');
      icon.src = groupArrow;
      applyIconStyles(icon);
      leftBtn.appendChild(icon);

      applyImageStyles(imgDiv, `${preview.url}#t=0.1`);
      leftBtn.appendChild(imgDiv);
    }

    const text = document.createElement('div');
    text.textContent = window.prevGroup.name || 'グループ名';
    applyTextStyles(text);
    leftBtn.appendChild(text);

    container.appendChild(leftBtn);
  }

  // — 右ボタン —
  if (window.nextGroup) {
    const rightBtn = document.createElement('div');
    rightBtn.className = 'rightGroupButtonFrame';
    applyButtonStyles(rightBtn, 'right');

    const preview = resolveGroupPreview(window.nextGroup);
    if (preview) {
      const imgDiv = document.createElement(preview.tagName);
      if (preview.tagName === 'video') {
        imgDiv.muted = true;
        imgDiv.src = `${preview.url}#t=0.1`;
        imgDiv.style.objectFit = 'cover';
        applyVideoDownloadSafeguards(imgDiv);
      }
      applyImageStyles(imgDiv, `${preview.url}#t=0.1`);
      rightBtn.appendChild(imgDiv);
    }

    const text = document.createElement('div');
    text.textContent = window.nextGroup.name || 'グループ名';
    applyTextStyles(text);
    rightBtn.appendChild(text);

    const icon = document.createElement('img');
    icon.src = groupArrow;
    applyIconStyles(icon, true);
    rightBtn.appendChild(icon);

    container.appendChild(rightBtn);
  }

  // コンテナ内の HTML を文字列で返す
  return container.innerHTML;
};
